import { Tag, TagProps } from '@grupoboticario/flora-react'
import { ChartDownIcon } from '@grupoboticario/flora-react-icons'
import { ProductTagService } from 'src/service/productTagService'

export type ProductTagProps = {
  tag: string
} & Omit<TagProps, 'children'>

export function ProductTag({ tag, ...tagProps }: ProductTagProps) {
  if (ProductTagService.isDiscount(tag)) {
    return (
      <Tag
        {...tagProps}
        variant="primary"
      >
        {tag}
      </Tag>
    )
  }

  if (ProductTagService.isLowStock(tag)) {
    return (
      <Tag
        {...tagProps}
        variant="alert"
        leftIcon={<ChartDownIcon />}
        css={{ ...tagProps.css, textTransform: 'capitalize' }}
      >
        {tag}
      </Tag>
    )
  }

  return (
    <Tag
      {...tagProps}
      shape="ghost"
    >
      {tag}
    </Tag>
  )
}
